// extracted by mini-css-extract-plugin
module.exports = {"installation-popup":"InstallationPopup_installation-popup__5v1IQ"};